import React from 'react'
import { FaThList, FaHammer, FaSearch, FaServer, FaGlobe, FaChartBar, FaBookOpen } from 'react-icons/fa'
import { HiOutlineBuildingOffice } from 'react-icons/hi2';
import { MdOutlineBalance } from 'react-icons/md';
import service_svg from '../../assets/Image/service_svg.svg'
import { Schedule } from '../../Component'

const Services = () => {

    let service_obj = [
        {
            icon: <HiOutlineBuildingOffice className='card_icon' />,
            title: 'Traditional',
            para: 'Our end-to-end service package for Traditional Enterprises.',
            para2: "We'll help you develop a basic understanding of Web3, offer a guided ideation program and support you during concept execution.",
        },
        {
            icon: <FaGlobe className='card_icon' />,
            title: 'WEB3 NATIVE',
            para: 'Our end-to-end service package for Web3 Native startups.',
            para2: "As a Web3 native protocol you can apply for our incubation program.We'll help you establish a sound business case, prepare documents and introduce you to investors.",
        },
        {
            icon: <FaBookOpen className='card_icon' />,
            title: 'EDUCATION',
            para: 'Our Web3 onboarding course for traditional enterprises.',
            para2: 'Our onboarding course is aimed at providing you a general understanding of blockchain, Web3 and its use cases.',
        },
        {
            icon: <FaChartBar className='card_icon' />,
            title: 'TOKENOMICS',
            para: 'Tokenomics engineering for token based economies.',
            para2: 'Advanced tokenomics design & simulation methods for sustainable token economies.',
        },
        {
            icon: <FaThList className='card_icon' />,
            title: 'SOLUTIONS',
            para: 'Take advantage of our whitelabel solutions for an efficient project implementation.',
            para2: 'Our wide range of tested products can help you set foot in the world of Web3 in an accelerated and cost - effective manner.',
        },
        {
            icon: <FaSearch className='card_icon' />,
            title: 'OSINT',
            para: 'Unlock the power of blockchain analytics using Open Source Intelligence.',
            para2: 'Gain insights into a blockchain, identify risks or monitor transactions & activities.Our services can help detect fraud, money laundering and other activities.',

        },
        {
            icon: <FaServer className='card_icon' />,
            title: 'VALIDATOR SETUP',
            para: 'Run your own proof of stake node on any EVM compatible chain.',
            para2: 'Decantralize your business practices with a private validator, independent of any third-party or authority.'
        },
        {
            icon: <MdOutlineBalance className='card_icon' />,
            title: 'DAO SETUP',
            para: 'End-to-end service for setting up a Decentralized Autonomous Organization.',
            para2: 'Set up a safe, transparent, decentralized and autonomous organization to govern a business & manage mutual funds.',
        },
    ]

    return (
        <>
            <div className='solution_main_div'>
                <div>
                    <div className='solution_list_icon_div'>
                        <FaHammer />
                    </div>
                    <div className='solution_list_text_div'>
                        <h4>OUR</h4>
                        <b>WEB3 SERVICES</b>
                    </div>
                </div>
                <div className='solution_inner_div1'>
                    <div className='solution_text_main_div'>
                        <div className='solution_list_text_div2' data-aos="fade-right" data-aos-duration='1500' data-aos-delay='200'>
                            <h4>OUR</h4>
                            <b>SERVICES</b>
                        </div>
                        <div className='solution_text_div'>
                            <p className='solution_p'>
                                We firmly believe in the growing importance of blockchain technology in today's digital world. Thus, we offer a wide range innovative services to help you leverage this technology to your advantage. Whether you're looking to create digital collectibles, use blockchain-based ticketing solutions, or develop NFT loyalty programs, we have the expertise to help.
                            </p>
                            <p className='solution_p2'>
                                Additionally, we offer OSINT (open-source intelligence) services, which provide blockchain analytics to help you gain insights and make data-driven decisions. With our DAO and validator setup services we help you to decentralize your business practices and establish fully transparent and decentralized decision-making processes with efficiency and security in mind.
                            </p>
                        </div>
                    </div>
                    <div className='solution_text_main_div2'>
                        <div>
                            <div className='service_list_text_div3' data-aos="fade-left" data-aos-duration='1500' data-aos-delay='200'>
                                <h4>A WIDE RANGE OF</h4>
                                <b>WEB3 SERVICES & COURSES</b>
                            </div>
                            <div className='solution_list_text_div4'>
                                <h4>Discover some potential </h4>
                                <b>Web3 services you could take advantage of</b>
                            </div>
                            <div className='solution_svg_div'>
                                <img src={service_svg} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='cards_main_div2'>
                    {
                        service_obj?.map((v, i) => {
                            return (
                                <div className='card_inner_div2'>
                                    <div className='card_icon_div2'>
                                        {v?.icon}
                                    </div>
                                    <div className='card_h3_div2'>
                                        <h3>
                                            {v?.title}
                                        </h3>
                                        <p>
                                            {v?.para}
                                        </p>
                                    </div>
                                    <div className='card_h3_div3'>
                                        <p>
                                            {v?.para2}
                                        </p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className='schedule_main_div'>
                    <Schedule heading="CAN'T FIND THE" bold="SERVICE YOU NEED?" heading2="Schedule a call or" bold2=' send us a message!' />
                </div>
            </div>
        </>
    )
}
export default Services